<template>
  <div class="app-area-picker">
    <el-button type="info" size="mini" @click="handleClick" plain>设置推广城市</el-button>
    <el-dialog
      width="840px"
      :visible.sync="dialogVisible"
      :show-close="false"
    >
      <div class="app-area-picker__inner">
        <div class="app-area-picker__header">
          <div>
            <h3 class="app-area-picker__title">设置推广城市</h3>
            <el-checkbox :indeterminate="areas[0].isIndeterminate" v-model="areas[0].checked" @change="handleChange(areas[0], $event)">所有区域</el-checkbox>
          </div>
          <a class="app-area-picker__btn-close" href="javascript:;" @click="handleClose">
            <app-svg-icon icon-class="close"></app-svg-icon>
          </a>
        </div>
        <div class="app-area-picker__body">
          <ul class="app-area-picker__area">
            <li class="app-area-picker__area__item" v-for="area in areas[0].children" :key="area.id">
              <div class="app-area-picker__area__item__left">
                <el-checkbox :indeterminate="area.isIndeterminate" v-model="area.checked" @change="handleChange(area, $event)">{{ area.label }}</el-checkbox>
              </div>
              <div class="app-area-picker__area__item__right">
                <span class="app-area-picker__checkbox-wrap" v-for="province in area.children" :key="province.id">
                  <el-checkbox :indeterminate="province.isIndeterminate" v-model="province.checked" @change="handleChange(province, $event)">{{ province.label }}</el-checkbox>
                  <!-- <span class="app-area-picker__checkbox-tip" v-if="!province.checked && province.children.filter(p => p.checked).length">({{ province.children.filter(p => p.checked).length }}/{{ province.children.length }})</span> -->
                  <el-popover placement="bottom" trigger="click">
                    <div class="app-area-picker__checkbox-group">
                      <span class="app-area-picker__checkbox-wrap" v-for="city in province.children" :key="city.id">
                        <el-checkbox v-model="city.checked" @change="handleChange(city, $event)">{{ city.label }}</el-checkbox>
                      </span>
                    </div>
                    <span class="app-area-picker__checkbox-arrow" slot="reference" style="font-size: 12px;">
                      <i class="el-icon-arrow-down"></i>
                    </span>
                  </el-popover>
                </span>
              </div>
            </li>
          </ul>
        </div>
        <div class="app-area-picker__footer">
          <a @click.prevent="handleClean">清除选择</a>
          <el-button type="primary" size="mini" @click="handleOk">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAreasTree,
  checkAll,
  checkItem,
  checkParent,
  findAllChecked
} from '@/assets/areas'

export default {
  name: 'AppAreaPicker',
  props: {
    defaultChecked: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      dialogVisible: false,
      areas: getAreasTree()
    }
  },

  created () {
    this.initChecked()
  },

  methods: {
    initChecked () {
      if (this.defaultChecked.length > 0) {
        checkItem(this.areas, this.defaultChecked)
        this.trigger('ok')
      }
    },

    handleChange (current, checked) {
      current.checked = checked
      current.checked && (current.isIndeterminate = false)
      current.children && checkAll(current.children, checked)
      current.parent && checkParent(current.parent)
      this.trigger('change')
    },

    trigger (event) {
      setTimeout(() => {
        const level = 2
        const checkeds = findAllChecked(this.areas, level)

        console.log('[DEBUG] checkeds', checkeds)
        this.$emit(event, checkeds)
      }, 0)
    },

    openDialog () {
      this.dialogVisible = true
    },

    closeDialog () {
      this.dialogVisible = false
    },

    handleClose () {
      this.closeDialog()
    },

    handleOk () {
      this.trigger('ok')
      this.closeDialog()
    },

    handleClean () {
      checkAll(this.areas, false)
      this.trigger('clean')
    },

    handleClick () {
      this.openDialog()
    }
  }
}
</script>

<style lang="scss">
.app-area-picker {
  display: inline-block;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    padding: 15px;
    border-bottom: 1px solid $border-color;
  }

  &__body {
    padding: 15px;
  }

  &__footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-top: 1px solid $border-color;
    background-color: #eee;
  }

  &__title {
    display: inline-block;
    margin: 0;
    margin-right: 15px;
  }

  &__btn-close {
    color: #999;
    transition: color .3s;

    &:hover {
      color: darken($color: #999, $amount: 20)
    }
  }

  &__area {
    padding: 0;
    margin: 0;
    list-style: none;

    &__item  {
      display: flex;
      margin: 10px 0;

      &__left {
        width: 100px;
      }

      &__right {
        flex: 1;
      }
    }
  }

  &__checkbox-group {
    max-width: 300px;
  }

  &__checkbox-wrap {
    display: inline-block;
    padding-right: 15px;
  }

  &__checkbox-arrow {
    cursor: pointer;
  }

}

.el-checkbox {
  +.el-checkbox {
    margin-left: 0;
  }
}
</style>
